import React, { useMemo } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import {
  CssBaseline,
  NoSsr,
  ThemeProvider,
  unstable_createMuiStrictModeTheme as createMuiTheme,
  useMediaQuery,
} from '@material-ui/core'
import { homeRoute, routes } from './routes'
import { withPage } from './pages'

export function App() {
  const browserRoutes = [...routes, homeRoute]
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')

  const theme = useMemo(
    () =>
      createMuiTheme({
        palette: {
          type: prefersDarkMode ? 'dark' : 'light',
        },
      }),
    [prefersDarkMode],
  )

  return (
    <NoSsr>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Switch>
            {
              browserRoutes.map(({ path, component, title }) => (
                <Route
                  key={path}
                  path={path}
                  render={(props) => {
                    const Page = withPage(component)

                    return <Page {...props} title={title} />
                  }}
                />
              ))
            }
          </Switch>
        </Router>
      </ThemeProvider>
    </NoSsr>
  )
}
